export default {
  lang: '語言',
  t1: '您的瀏覽器不支持自動播放視頻。',
  t2: '四十有為 卓越吾鄉',
  t3: '城市傳奇',
  t4: '致敬經典',
  t5: '新聞動態',
  t6: '投關資訊',
  t7: '美好生活領創者',
  t8: '探索更多',
  t9: '至真 致美 置吾鄉',
  t10: '股份代號',
  t11: '保利置業集團有限公司',
  t12: '最新公告',
  t13: '私隱說明',
  t14: '法律聲明',
  t15: '保利置業',
  t16: '可持續發展',
  t17: '多元業務',
  t18: '商旅服務',
  t19: '房地產開發',
  t20: '物業服務',
  t21: '科技創新',
  t22: '保利待客之道',
  t23: '締造吾鄉歸家之感',
  t24: '全國佈局',
  t25: '個城市',
  t26: '個項目',
  t27: '服務',
  t28: '聯繫我們',
  t29: '保利置業集團',
  t30: '地址：香港夏慤道18號海富中心第一期2503室',
  t31: '香港',
  t32: '電話',
  t33: '傳真',
  t34: '電郵',
  t35: '地址',
  t36: '心安吾鄉',
  t37: '保利置業香港股票代碼',
  t38: '保利置業集團有限公司(00119.HK)，簡稱保利置業，總部設在香港和上海，於香港聯交所主板上市，公司控股股東為保利(香港)控股有限公司，前身為成立於1985年的嶸高貿易有限公司。作為中國保利集團地產主業的重要柱石、資本市場的重要平台和海外佈局的重要窗口，保利置業已形成以境內外高端房地產開發、城市綜合投資運營、城市美好生活服務、科技創新為主要業務板塊，以集團優質產業資源融合為支撐的「兩輪、雙翼、多元驅動」發展戰略。',
  t39: '保利置業房開平台業務涉及房地產投資開發、銷售、自持物業運營管理，分佈在香港、上海、江蘇、浙江、廣東、深圳等11個區域、30多個城市，在建擬建項目過百。保利物業管理項目業態涉及住宅、商業、寫字樓、綜合體、銷售案場、公服等，分佈在上海、江蘇、浙江等11個區域41個城市，簽約項目超過300個，簽約面積達到6000萬平方米。酒店管理業務除擁有自營品牌酒店外，分別與洲際酒店（IHG）、凱悅酒店（Hyatt）等國際知名酒店管理集團合作，經營四星、五星酒店十餘家。',
  t40: '業務佈局',
  t41: '中國保利集團以多元業態紮根核心戰略城市群，業務遍及國內百餘個城市，與全球',
  t42: '多個國家和地區保持密切業務往來，目前共有',
  t43: '多家境外機構進駐全球',
  t44: '個國家和地區，形成了覆蓋全球的營銷網絡和業務支點，有力支撐中國保利集團業務拓展。',
  t45: '進入新發展階段，中國保利集團圍繞「建設一流、追求卓越」戰略目標，以習近平新時代中國特色社會主義為指導，完整、準確、全面貫徹新發展理念，融入和構建新發展格局，增強「四個意識」、堅定「四個自信」、做到「兩個維護」，牢記「國之大者」，充分發揮國有資本投資公司功能作用，踐行服務國家產業佈局和結構優化的使命，加強「管資本」能力建設，以改革創新為動力，以風險防控為關鍵，以精益管理為抓手，進一步增強競爭力、創新力、控制力、影響力和抗風險能力，打造形成具有國際競爭力、國內領先的「5+1」業務體系，為廣大人民群眾提供「高端、高質、高品」的產品和服務，滿足人民對高品質美好生活的嚮往，以優秀業績回饋股東、客戶、社會、國家，為打造保利百年老店，實現基業長青而不懈奮鬥！',
  t46: '目前，中國保利集團擁有11家主要子公司，職工10萬人，境內外控股上市公司5家，分別為：保利發展控股集團股份有限公司（股票代碼：S.H.600048）、保利置業集團有限公司（股票代碼：H.K.00119）、中國海誠工程科技股份有限公司（股票代碼：S.Z.002116）、保利聯合化工控股集團股份有限公司（股票代碼：S.Z.002037）、保利物業服務股份有限公司（股票代碼：H.K.06049）。',
  t47: '中國保利集團有限公司（以下簡稱「中國保利集團」或「集團」）是經國務院、中央軍委批准組建，由國務院國有資產監督管理委員會直接管理的大型中央企業。成立40年來，保利已形成「優化貿易、升級地產、做強文化、創新科技、做特工程、金融支撐」的「5+1」業務體系，成為業務範圍涵蓋衣食住行用和精神文化生活等方面的多元化企業集團，業務遍佈國內100多個城市及全球近百個國家。中國保利集團位列2024年《財富》世界500強第173位，13次獲國務院國資委業績考核A級。',
  t48: '中國保利集團有限公司',
  t49: '億元',
  t50: '品牌價值位居綜合服務領域榜首',
  t51: '中央企業品牌建設榜單位列第',
  t52: '位',
  t53: '中國保利',
  t54: '我們重視業務往來過程中的公正廉潔承諾與審查，持續推進陽光採購工程。供應商必須提供《廉潔合作承諾》作為入庫呈批必要附件；在合同簽約階段，雙方須簽署《廉潔合作協議》《保利置業營銷採購招標陽光宣言》，作為合同必要附件。秉持着「依法依規、預防為主、公平公正、公開透明」的原則，我們根據《中國保利集團有限公司供應商廉潔黑名單管理辦法》，建立供應商廉潔黑名單管理，對黑名單內的供應商施行「一處違規、處處受限」聯合懲戒機制，完善供應商廉潔管理及監督體系，規範供應商廉潔從業行為。',
  t55: '作為中國保利集團地產主業的重要柱石、資本市場的重要平台和海外佈局的重要窗口，保利置業已形成以境內外高端房地產開發、城市綜合投資運營、城市美好生活服務、科技創新為主要業務板塊，以集團優質產業資源融合為支撐的「兩輪、雙翼、多元驅動」發展戰略。',
  t56: '保利置業卓越發展戰略',
  t57: `兩輪 雙翼 多元驅動`,
  t58: `遵循中國保利集團「保國利民
              追求卓越」使命，保利置業多年秉承高度社會責任感，踐行央企擔當。翻開時光履歷，自2021年起，保利置業發起「保利少年志」公益行動，以志為核，現已覆蓋全國13大區域、30多座城市，累計助力萬餘中國青少年築夢圓夢。`,
  t59: `助力中國兒童美學教育和理想啟蒙`,
  t60: `2021年，保利置業發起大型公益行動「保利少年志」，助力中國兒童美學教育和理想啟蒙。近年來，保利置業承擔了貴州、廣西、海南等多個地區定點幫扶，累計投入幫扶資金6000多萬，彰顯了央企責任和家國情懷。;`,
  t61: `2021年，保利置業發起大型公益行動「保利少年志」，助力中國兒童美學教育和理想啟蒙。近年來，保利置業承擔了貴州、廣西、海南等多個地區定點幫扶，累計投入幫扶資金6000多萬，彰顯了央企責任和家國情懷。;`,
  t62: `2000年5月，保利在香港積極參與搶救流失海外的祖國珍貴文物，相繼迎回猴首、牛首和虎首，漂泊海外140年的國寶獸首，終於回到闊別已久的故鄉。此後，港澳企業家何鴻燊博士捐贈了豬首。如今，四座圓明園獸首相聚在保利藝術博物館，它們失而復得的經歷，刻畫着一個世紀跌宕起伏的歷史滄桑，也書寫着一個民族的復興歷程與家國情懷。;`,
  t63: `1999年，中國數碼技術產業端倪初現，保利星在北京電子城工業園正式成立。24年來，保利星包攬了行業內所有國家級、省部級獎項，先後為行業制定國家標準3項、行業標準20項、團體標準1項，連續20年被認定為國家高新技術企業。2019年，保利星公司正式成立了以微流控生物晶片設計研發為主導的新公司——北京保利微芯科技有限公司，實現了技術密集型產業跨向知識密集型產業的賽道轉換。;`,
  t64: `上海保利物業酒店管理集團有限公司 (以下簡稱保利物業)
                      於1996年12月在北京成立，隸屬於保利置業集團，是首批國家一級資質物業管理企業，目前管理業務涉及住宅物業、商務寫字樓、商業綜合體、城市運營和景區公共服務等多元物業服務體系。;`,
  t65: `1993年1月，順應時代的保利毅然投身浦東開發。中國保利集團在上海的第一個項目——上海證券大廈奠基儀式在滬舉行，它見證了上海浦東乃至中國改革開放發展歷程。同時期，參與投資、開發、建造廣州中信廣場，這是彼時中國內地最高的商業建築，也是改革開放的標誌性工程。;`,
  t66: `保利置業的誕生、成長與壯大，與國家戰略發展緊密相連。1993年，中國保利集團完成香港上市公司新海康航業投資有限公司(H.K.
          00119) 55%的股權收購，實現在港主板上市。保利
          （香港）控股先後參與廣州中信廣場、北京新保利大廈等項目開發建設，佈局香港龍譽、瑧譽、沄璟等多個行業標杆，累計在港創造數千個崗位，服務近千個家庭。;`,
  t67: `1992年，中國保利集團取得第一張涉外國有土地使用證（京中外國用（92）字第0001號）。這份土地證見證了麗京花園項目從籌建、選址、立項、施工，到銷售、物業管理的每一個環節。作為北京市第一個涉外商品房項目，也是中國保利集團第一個房地產項目，在內地和香港兩地同時銷售的麗京花園，吸引大量華僑、港澳台同胞購買定居，創下了「4小時銷售60套」的保利傳奇。第一張涉外國有土地使用證，親鑒一代代保利人進取的奮鬥史，成為保利人奮進的精神力量。;`,
  t69: `2022年7月，保利商旅酒店管理有限公司（簡稱保利商旅酒店）正式成立，開啟酒店輕資產業務運營模式。目前，保利商旅酒店管理業務除擁有自營品牌酒店外，分別與洲際酒店
          (IHG) 、凱悅酒店 (Hyatt)
          等國際知名酒店管理集團合作，在上海、北京、武漢、湖州、柳州、貴陽、順德等城市的優質地段打造、經營四星、五星酒店九家。;`,
  t70: `2023年，保利置業登榜中指研究院「2023優秀房地產上市公司名單」，榮登「2023中國大陸在港上市房地產公司財富創造能力」、「2023中國大陸在港上市房地產公司財務穩健性」、「2023中國大陸在港上市房地產公司投資價值」、「2023中國房地產上市公司治理」四大榜單top10，收穫了資本市場和行業的認可肯定，彰顯保利置業良好發展態勢和長遠的發展潛力。;`,
  t71: `保利置業洞察時代與行業發展趨勢，從客戶需求出發，以「心安吾鄉」為品牌主張，以人本主義為精神內核，以產品主義為硬核實力，以專業主義為重要抓手，始終堅持長期主義為發展導向，以「至真、致美、置吾鄉」為客戶宣言，通過產品、服務、文化、責任為四大品牌建設觸點，提升市場化品牌影響力，以產品力、服務力、營銷力、運營力、成本力(品質五力)為業務基石，打造具有卓越競爭力的品牌生態鏈，最終實現「保利是吾鄉」品牌願景，為廣大客戶和業主兌現美好期許。;`,

  t73: `發展歷程`,
  t74: `品牌文化`,
  t75: `組織架構`,
  t76: `關於我們`,
  t77: `中國保利集團`,
  t78: `保利置業依託保利集圍強大的資源協同支撐，實現產業全面升級，打造境內外高端房地開發、城市綜合投資運營、城市美好生活服務、科技創新4大業務板塊，形成「兩輪、雙翼、多元驅動」卓越發展戰略：以境內外高端房地產開發和城市綜合投資運營為「兩輪」，通過兩大核心業務的合理組合及良性發展，鞏固行業領先地位；以城市美好生活服務和綜合金融服務為「雙翼」，塑造企業持續發展特色，助力業務發展；同時協同中國保利集團多項優質產業資源實現「多元驅動」，全面提升城市綜合運營服務能力，實現企業高質量可持續發展。`,
  t79: `住宅開發`,
  t80: `住宅服務 商寫服務 城市服務`,
  t81: `酒店 健身 商業`,
  t82: `保利微芯 保利星`,
  t83: `二零二四年十一月未經審核銷售數據`,
  t84: `本站點（以下簡稱保利）非常重視對您的個人私隱保護，有時候我們需要某些信息才能為您提供您請求的服務，本私隱聲明解釋了這些情況下的數據收集和使用情況。`,
  t85: `本私隱聲明適用於保利的所有相關服務，隨着保利服務範圍的擴大，私隱聲明的內容可由保利隨時更新，且毋須另行通知。更新後的私隱聲明一旦在網頁上公佈即有效代替原來的私隱聲明。`,
  t86: `我們收集哪些信息`,
  t87: `通常，您能在匿名的狀態下訪問保利並獲取信息。當我們需要能識別您的個人信息或者可以與您聯繫的信息時，我們會徵求您的同意。通常，在您註冊保利或申請開通新的功能時，我們可能收集這些信息：姓名，Email地址，住址和電話號碼，並徵求您的確認。`,
  t88: `關於您的個人信息`,
  t89: `保利嚴格保護您個人信息的安全。我們使用各種安全技術和程序來保護您的個人信息不被未經授權的訪問、使用或泄露。保利會在法律要求或符合保利的相關服務條款、軟件許可使用協議約定的情況下透露您的個人信息，或者有充分理由相信必須這樣做才能：（a）滿足法律或行政法規的明文規定，或者符合保利網站適用的法律程序；（b）符合保利相關服務條款、軟件許可使用協議的約定；（c）保護保利的權利或財產，以及（d）在緊急情況下保護保利員工、保利產品或服務的用戶或大眾的個人安全。\n            保利不會未經您的允許將這些信息與第三方共享，本聲明已經列出的上述情況除外。`,
  t90: `Cookie的使用`,
  t91: `使用Cookie能幫助您實現您的聯機體驗的個性化，您可以接受或拒絕Cookie，大多數Web瀏覽器會自動接受Cookie，但您通常可根據自己的需要來修改瀏覽器的設置以拒絕Cookie。`,
  t92: `保利有時會使用Cookie以便知道哪些網站受歡迎，使您在訪問保利時能得到更好的服務。Cookie不會跟蹤個人信息。當您註冊保利時，保利亦會使用Cookie。在這種情況下，保利會收集並存儲有用信息，當您再次訪問保利時，我們可辨認您的身份。來自保利的Cookie只能被保利讀取。`,
  t93: `如果您的瀏覽器被設置為拒絕Cookie，您仍然能夠訪問保利的大多數網頁。`,
  t94: `關於免責說明`,
  t95: `就下列相關事宜的發生，保利不承擔任何法律責任：`,
  t96: `*由於您將用戶密碼告知他人或與他人共享註冊帳戶，由此導致的任何個人信息的泄露，或其他非因保利原因導致的個人信息的泄露；`,
  t97: `*保利根據法律規定或政府相關政策要求提供您的個人信息；`,
  t98: `*任何第三方根據保利各服務條款及聲明中所列明的情況使用您的個人信息，由此所產生的糾紛；`,
  t99: `*任何由於黑客攻擊、電腦病毒侵入或政府管制而造成的暫時性網站關閉；`,
  t100: `*因不可抗力導致的任何後果；`,
  t101: `*保利在各服務條款及聲明中列明的使用方式或免責情形。\n            \n            本通知以中文撰寫，並可能翻譯成其它語言。如中文版本與翻譯版本有任何歧異，概以中文版本為準。`,
  t102: `黨的二十大報告提出：公益慈善力量在以中國式現代化全面推進中華民族偉大復興中，有着不可替代的重要作用。遵循中國保利集團「保國利民\n            追求卓越」企業使命，保利置業多年來秉承高度的社會責任感和使命感，為建設社會主義文化強國積極貢獻國資央企力量。`,
  t103: `保利少年志：賡續央企擔當書寫美好新答卷`,
  t104: `以志為核放飛少年夢想`,
  t105: `貢獻「保利力量」`,
  t106: `2021年，保利置業帶領9名大山少年飛躍大山，前往北京天安門、故宮、長城等地參觀，捐建「保利藝術教室」「保利夢想圖書室」並投入使用。2022年，開展「保利少年志·千里課堂」，全國11位夢想導師跋涉9300餘公里，為66名大山孩子帶來人文、藝術、理想啟蒙課程。2023年，首次聯動「保利星火教育金」，在全國7個定點幫扶縣設置「保利少年志·星火教育金」，共捐贈210萬元、覆蓋1289名師生，夯實人才振興、文化振興的重要基石。`,
  t107: `三年成長、三年逐夢。保利少年志已打造成為具有社會影響力和品牌美譽度的公益品牌，先後在國企好新聞、中央企業品牌建設典型案例、中央企業優秀品牌故事、中央企業社會主義核心價值觀主題微電影展映等評選中斬獲榮譽，併入選《中央企業社會責任藍皮書》。以「美好生活領創者」之姿，保利置業將持續以品牌建設，為加快實現中國現代化新征程貢獻「保利力量」。`,
  t108: `保利少年志·公益資訊`,
  t109: `聚焦少年理想啟蒙，實時傳遞公益動態`,
  t110: `讓夢想發光，大山裏的小夢想循光啟航。`,
  t111: `千里課堂，翻越山丘，為少年種下夢想的種子。`,
  t112: `「保利星火教育金」走進河曲，為山區少年夢想助力。`,
  t113: `保利少年志·公益短片`,
  t114: `啟迪少年成長之旅，講述奮鬥追夢故事`,
  t115: `保國利民 追求卓越`,
  t116: `點亮守護孩子的夢想之光，為大國崛起的未來聚力扛鼎`,
  t117: `保利少年志·公益光影`,
  t118: `記錄少年奮鬥足跡，定格追夢美好瞬間`,
  t119: `投資者關係`,
  t120: `業績簡報`,
  t121: `公司資料`,
  t122: `企業管治`,
  t123: `公告及通函`,
  t124: `年度/中期報告`,
  t125: `環境、社會及管治報告`,
  t126: `投資者通訊`,
  t128: `2024年中報`,
  t130: `以人為本`,
  t131: `精益管治`,
  t132: `美好生活`,
  t133: `綠色家園`,
  t134: `同享共創`,
  t135: `職業健康與安全`,
  t136: `員工管理`,
  t137: `保利置業建立健全職業健康與安全管理體系，加強員工安全培訓，開展日常巡檢和定期維護，並通過員工溝通、開展豐富多彩的員工關愛與幫扶活動，為員工創造安全無憂的工作環境。`,
  t138: `安全管理體系`,
  t139: `本集團遵循《中華人民共和國安全生產法》《中華人民共和國消防法》《中華人民共和國特種設備安全法》等職業健康和保障安全工作環境的相關法律法規，制定《保利置業安全生產監督管理辦法》《保利置業安委會工作辦法》《保利置業生產安全事故綜合應急預案》等內部制度，全面推進安全生產及職業健康管理體系建設，確保風險持續受控、安全形勢保持穩定。`,
  t140: `本集團制定年度安全管理標準化行動清單，成立安全管理委員會，各級負責人需按計劃執行五項安全管理動作，包括年度培訓、檢查、隱患排查、應急演練和事故報告，並督導重大隱患整治等任務。分管負責人和安全管理部負責落實月度檢查、會議、應急演練、檔案管理和季度報告等管理動作。`,
  t141: `2023年，本集團全系統安全生產管理架構初步搭建完成，為安全管理體系高效運轉提供有力的組織保證。保利物業、保利（香港）物業已通過ISO 45001 職業健康安全管理體系認證。`,
  t142: `安全文化建設`,
  t143: `2023年，本集團組織開展多種安全生產相關培訓，包括安全應急演練、安全生產月、消防安全月等內容，全面提升員工職業健康與安全的專業能力，為健康安全工作有效落地奠定良好基礎，持續夯實安全底線。`,
  t144: `應急演練活動`,
  t145: `開展多項應急演練活動，包括基坑坍塌、模板坍塌、腳手架坍塌、高處墜落、機械傷害、火災、觸電、中暑等事故或人員傷害等內容。參與演練員工深刻學習相關的安全生產知識，提高了員工安全生產意識以及事故急救技巧。`,
  t146: `4.15全民國家安全教育日`,
  t147: `開展4·15 全民國家安全教育日系列活動。通過開設線上學習專欄、辦公區張貼國家安全宣傳展板，組織觀看國家安全宣傳片，參觀保密教育實訓基地，開展網絡安全知識測試和網絡安全專項檢查等融合互動形式，進一步增強員工安全意識。`,
  t148: `保利商旅「安全生產月」「消防安全月」`,
  t149: `培訓活動內容涵蓋規章制度、操作規程、技術標準規範等，通過培訓，員工的安全防範意識得到提升，全年共開展164次安全生產培訓，覆蓋3,446人次。`,
  t150: `住宅小區防汛演習`,
  t151: `觀看警示教育片`,
  t152: `保利商旅安全培訓活動`,
  t153: `員工溝通`,
  t154: `本集團嚴格遵守《中華人民共和國工會法》《中國工會章程》《企業工會工作條例》《企業民主管理規定》相關要求，制定《保利置業集團有限公司加強工會工作實施辦法》《保利置業集團有限公司廠務公開實施辦法》等管理辦法，完善職工代表大會制度，探索職工群眾參與管理的有效方式。`,
  t155: `我們切實保障職工群眾的知情權、參與權、表達權，提升企業民主管理發展的質量與效果。我們建立平等協商溝通渠道，通過談心談話、走訪調研、座談交流、在線意見徵集、設置信訪箱等渠道傾聽員工聲音，並於總部設立董事長信箱，進一步暢通職工群眾溝通渠道。`,
  t156: `員工關愛`,
  t157: `本集團重視員工工作與生活平衡，建立並完善員工服務與關愛體系，組織多樣化員工幫扶、文體活動，提高員工企業歸屬感，努力打造和諧、溫暖、幸福的職場環境。`,
  t158: `2023 年，我們為困難職工申請保利愛心基金，幫扶員工9 人，共計完成發放補助款58,450 元。同時，我們開展金秋助學活動，助力職工子女就近入學。`,
  t159: `芳菲三月，美好如你\n花樣活動共慶「三八」婦女節`,
  t160: `圍繞「自尊、自信、自立、自強」的新時代女性精神，開展致敬「她力量」關心關愛女性職工主題宣傳活動，各級工會組織花樣主題活動，豐富女性職工業餘文化生活，展現保利麗人熱愛生活、昂揚向上的美好態度和卓越風采。`,
  t161: `採春品茗 夏雅的你最美活動`,
  t162: `「保」持熱愛 全「利」以赴\n2023 年長三角地區趣味運動會`,
  t163: `舉辦2023年長三角地區趣味運動會。本次運動會作為「保利是吾鄉」企業文化建設行動的重要環節，不僅加強幹部與員工之間的交流，更加強了企業凝聚力、振奮了精神、增進了友誼，展現出保利置業人奮發進取、昂揚向上的精神風貌。`,
  t164: `2023年長三角地區趣味運動會`,
  t165: `工會興趣小組`,
  t166: `本集團工會成立多個興趣小組，培育健康文明、積極向上的職工文化，興趣小組涵蓋瑜伽、羽毛球、籃球、足球等。各區域也成立游泳、繪畫、茶藝等職工文體小組，並組織各類文體活動，如樂跑、籃球友誼賽、羽毛球賽等，共同打造有溫度的「保利家園」。`,
  t167: `工會興趣小組`,
  t168: `保利置業秉持「責任為本 發展至上」的核心價值觀，致力於保障員工權益，提供健全薪酬福利體系，創造平等包容的職場環境。我們建立廣闊的人才發展平台，定期開展豐富的活動為員工送去溫暖與關懷，持續提升員工的幸福感與歸屬感。`,
  t169: `合規僱傭`,
  t170: `本集團嚴格遵守國家及各營運地的法律法規，建立並優化各項管理制度，規範在員工招聘僱傭方面的管理要求。`,
  t171: `本集團未發生過僱傭童工與強制勞工事件。`,
  t172: `我們遵守《中華人民共和國未成年人保護法》《禁止使用童工規定》等相關規定，要求下屬所有企業不得招用童工，並通過建立規範嚴謹的招聘及日常員工管理制度避免招用童工。同時，我們依法禁止強制勞動行為，若發現疑似情況將立刻發起調查，如涉嫌構成強迫勞動罪，將進行依法處理。`,
  t173: `多元包容`,
  t174: `本集團秉承多元包容的原則，堅決杜絕在人員招聘及發展過程中出現任何因年齡、宗教信仰、國籍、婚姻狀態、種族、膚色、民族、身體狀況、性別認同等因素而產生的歧視行為。`,
  t175: `福利保障`,
  t176: `本集團遵守各項法律法規，嚴格執行國家及地方社會保障機制。我們通過制定科學完善的薪酬激勵制度，為員工提供富有競爭力的薪資，保障人才的吸納及留存，實現企業與員工的利益共享。對於相同工作、付出等量勞動且取得相同業績的員工，我們承諾給予同等的勞動報酬及福利待遇。`,
  t177: `此外，我們為員工提供完善的福利保障，通過持續提升員工的福利待遇和優化關懷措施，讓員工能夠更加安心、舒適地投入到工作中。`,
  t178: `法定福利`,
  t179: `為員工繳納養老、失業、醫療、工傷及生育保險，並繳納住房公積金。`,
  t180: `根據經濟效益情況安排為員工繳納年金、補充公積金等。`,
  t181: `公司福利`,
  t182: `為員工提供就餐安排。`,
  t183: `為員工提供交通費、通訊費。`,
  t184: `發放節日費(如春節、元旦、端午、中秋等)。`,
  t185: `提供形式多樣、內容豐富的員工活動。`,
  t186: `培訓發展`,
  t187: `本集團致力於構建全方位的人才培養體系，為員工量身定製職業發展規劃，建立清晰的職業發展路徑。我們不斷優化和完善覆蓋人才發展全生命周期的管理體系，通過打造多元化成長發展平台，加強人才儲備，提升人才專業化，實現企業與個人共同成長。`,
  t188: `中國保利集團-「以卓越向未來」新員工培訓項目`,
  t189: `保利置業舉辦「以卓越向未來」新員工培訓，幫助新員工加強對公司戰略理解、管理要求掌握、文化理念認同、組織團隊融入、廉潔意識強化，讓新員工切身感受保利人的奮鬥青春及「以匠心為城市創造經典地標」的追求，為公司可持續發展提供人才儲備。`,
  t190: `新員工參觀標杆項目`,
  t191: `浙江公司-「菁英計劃」項目經理培訓項目`,
  t192: `浙江公司開展「菁英計劃」工作坊，圍繞項目經理能力素質模型、項目經理素養提升、項目工程問題開展專項培訓，以企業戰略發展需要為出發點，強化項目經理隊伍的核心競爭力。`,
  t193: `浙江公司2023年項目經理「菁英計劃」`,
  t194: `山東公司-「領睿計劃」中層管理培訓項目`,
  t195: `山東公司組織開展中層管理者「領睿計劃」培訓，系統學習產品力提升、項目管理等相關課程，幫助核心人員掌握更為科學的管理邏輯、工具方法，在行業形勢不斷變化的情況下持續提升應變能力。`,
  t196: `山東公司「領睿計劃」中層管理培訓`,
  t197: `貴州公司-「管理素質提升賦能」培訓項目`,
  t198: `貴州公司組織核心人員開展「管理素質提升賦能」培訓，通過豐富多元的培訓方式，加深管理者對人才管理知識及人才管理技能的理解，進一步提升管理人員綜合管理素質。`,
  t199: `貴州公司管理素質提升賦能培訓`,
  t204: `公告及通函`,
  t212: `年份`,
  t213: `全部`,
  t214: `公司經營通訊`,
  t215: `月度銷售通訊`,
  t216: `業績通訊`,
  t218: `ESG管治架構`,
  t219: `商業道德`,
  t220: `建立自董事會而下的管治架構`,
  t221: `ESG治理架構`,
  t222: `董事會`,
  t223: `作為公司ESG工作的最高領導和決策機構，負責審核及通過ESG工作戰略、目標、政策及ESG報告，並檢視公司年度ESG目標完成情況。`,
  t224: `董事會ESG委員會`,
  t225: `獲董事會授權，履行ESG事宜的領導和監督職責，負責協助董事會監察公司的ESG工作戰略、目標、政策及ESG報告，評估及厘定與公司業務相關的ESG重大風險，並直接向董事會匯報ESG工作。`,
  t226: `ESG工作領導小組`,
  t227: `由公司全體高級管理人員組成，負責擬定公司ESG工作戰略、目標、政策，統籌ESG報告的編制工作，監督各職能中心和子公司的ESG目標落實和執行，並定期向董事會ESG委員會匯報工作及提供建議。`,
  t228: `ESG工作執行小組`,
  t229: `由全體職能中心和主要子公司負責人組成，負責落實領導小組下發的ESG政策和措施，參與編制公司ESG報告，及時向領導小組提供ESG工作建議及相關風險事件，定期匯報ESG工作進度，包括關鍵指標。`,
  t230: `雙碳目標`,
  t231: `2030年努力實現經營性物業範圍一及二單位面積碳排放強度降低20%以上（以2023年為基準），爭取2060年實現碳中和。`,
  t232: `我們承諾，100% 的新獲取項目至少按照中國綠色建築基本要求進行設計。`,
  t233: `可持續發展貸款`,
  t234: `我們與9家主要的國際及本地銀行成功簽署首筆39 億港幣可持續發展掛鈎銀團貸款。本公司共選擇3個ESG相關指標，分別為溫室氣體排放強度、水資源使用強度及ESG培訓時數，並設定相應目標，通過實現目標即可減少成本的激勵方式，督促本公司提升可持續發展績效表現。`,
  t235: `保利置業堅決貫徹「廉潔自律，干凈幹事」的理念，深入推進「不敢腐、不能腐、不想腐」體制機制建設。我們制定了《保利置業集團有限公司廉潔風險防控手冊》《保利置業關於推動廉潔教育走深走實的實施意見》等內部制度，明確道德紅線，竭力打造公正廉潔的營商環境和文化氛圍。報告期內，本集團未發生貪污腐敗相關的訴訟和案件。`,
  t236: `保利置業開展商業道德及反貪腐`,
  t237: `培訓`,
  t238: `次`,
  t239: `累計參與`,
  t240: `人`,
  t241: `培訓總時長`,
  t242: `小時`,
  t243: `其中，向董事提供的商業道德及`,
  t244: `反貪腐培訓共計`,
  t245: `舉報機制`,
  t246: `本集團建立了完善的舉報機制，支持員工、供貨商、合作夥伴通過信訪地址、電話、電子郵箱等渠道進行實名或匿名舉報。我們嚴謹受理每一個舉報投訴，全力維護公司的廉潔文化。`,
  t247: `投訴舉報接收`,
  t248: `舉報信函和提交的書面材料：逐件拆閱、登記，及時處理，嚴防舉報信件丟失`,
  t249: `當面舉報：單獨進行溝通，詳細記錄；電話舉報：細心接聽，如實記錄`,
  t250: `短訊、微信、電子郵件進行的舉報：整理成文字材料，並註明來源和日期`,
  t251: `分類處理`,
  t252: `屬於集團審計和風險管理中心受理範圍的舉報，填寫《保利置業集團有限公司信訪舉報問題線索呈辦單》`,
  t253: `屬於子公司審計和風險管理中心受理範圍的舉報，發函轉交相關子公司處理`,
  t254: `為保護舉報人私隱及安全，我們在調查處理實踐過程中，案件核查人員須簽訂《保密承諾書》，嚴防泄露舉報內容及信訪個人信息，力求確保所有員工不會因為表達關切或報告不合規或不合法行為遭受不當傷害。任何對舉報人進行報復的個人或團體公司將視情節進行相應處罰，並為員工提供相應的保護措施。`,
  t255: `舉報政策`,
  t256: `版權聲明`,
  t257: `本網站上為版權人所有的文件，在此並末作任何授權。本網站上的文件僅限於為信息和非商業或個人之目的使用，並目不得在任何網絡計算村上複製或公佈，也不得在任何媒體上傳播。未經版權人許可，任何人不得擅自(包括但不限於:以非法的方式複製、傳播、展示、鏡像、上載、下載)使用。否則版權人將依法追究其法律責任。`,
  t258: `免責聲明`,
  t259: `版權人擁有對本網站的內容進行隨時更改之權利，事前將不會另行通知。版權人不保證或聲明本網站展示的資料是否正確、全面或是最新數據。`,
  t260: `本網站內的所有圖片(包括但不限於插圖、透視圖、設計圖等)、模型、文字描述等，僅作為參考信息，非開發商的任何承諾或要約，開發商聲明:網站有關其開發項目信息的介紹，均以政府最後審批文件為準。商品房買賣雙方之間的關係以當事人簽訂的買賣雙方之間的關係以當事人簽訂買賣合同為準。`,
  t261: `任何人因本網站或依賴其內容進行交易所引致的損失，版權人和開發商均不承擔任何責任。`,
  t263: `保利置業海南半島1號遊艇薈榮膺GFDA2024 Gold Winner 休閒建築類金獎`,
  t264: `心安吾鄉丨二十載卓越同行，領創美好心安荊楚`,
  t265: `限時投票！速來助力致美紅盤C位出道`,
  t266: `心安家書 | 家音寄暖，點亮人文服務之光`,
  t267: `保利置業合約銷售額 截至2024年11月30日止十一個月約為人民幣521億元`,
  t268: `保利置業合約銷售額 截至2024年10月31日止十個月約為人民幣489億元`,
  t269: `公司通訊 - 2024年第三期`,
  t270: `保利置業合約銷售額 截至2024年9月30日止九個月約為人民幣402億元`,
  t271: `高端地產開發`,
  t272: `探索更多`,
  t273: `積極踐行央企責任與擔當`,
  t274: `本集團將永葆初心使命，貫徹新發展理念，提升精益管理水平，為經濟發展、民生改善貢獻保利力量。`,
  t280: `品質五力`,
  t281: `保利置業敏銳洞察行業發展趨勢，夯實"品質五力"核心競爭力，以向上攀升的卓越追求，實現企業高品質發展。`,
  t287: `綠色開發`,
  t288: `綠色經營`,
  t289: `綠色生態修復`,
  t290: `在國家「碳達峰、碳中和」戰略目標背景下，保利置業積極探索房地產行業綠色高質量發展路徑。本集團秉持綠色投資與設計理念，遵循《綠色建築評價標準》（GB/T 50378-2019）要求，推進綠色建築開發，不斷探索綠色建築技術開發、材料應用與建造實踐，打造綠色建築典範，共築美麗家園。`,
  t291: `綠色建築`,
  t292: `我們承諾，100%的新獲取項目將至少按照中國綠色建築基本要求進行設計。`,
  t293: `上海保利印象青城`,
  t294: `超低能耗建築`,
  t295: `建築(1.2版)銀級認證`,
  t296: `上海保利琅譽`,
  t297: `近零能耗建築`,
  t298: `上海蘭州路項目`,
  t299: `濟南保利瓏譽`,
  t300: `綠色三星建築`,
  t301: `香港朗譽`,
  t302: `綠建環評新建`,
  t303: `綠色建材`,
  t304: `在建築建材的選擇上，我們在注重材料質量的同時，優先選用低消耗、低能耗、無污染、多功能的材料。2023年，我們持續提高綠色建材要求，探索綠色建材應用。`,
  t305: `綠色建材應用`,
  t306: `防水材料使用環保性能更優的高分子卷材、可揮發性物質含量更低的聚氨酯塗料等`,
  t307: `外牆採用外牆保溫一體化板，提高建築物保溫隔熱性能`,
  t308: `多聯機空調要求使用R410A環保冷媒，無毒，不含氯元素，不對臭氧層產生破壞，更加安全健康`,
  t309: `綠色技術`,
  t310: `裝配式技術`,
  t311: `本集團在建造技術上逐步推進裝配式建築標準化設計和生產體系建設，擴大標準化構件和部品部件的使用規模，提高建築綜合效益。在裝配式建築的技術應用上，我們不斷採用、實踐新型技術標準，提高項目質量和效益，以技術帶動綠色發展。`,
  t312: `BIM技術`,
  t313: `本集團全面推廣應用BIM技術，通過數碼化協同發展實現校驗設計圖紙、減少設計錯漏、提升溝通效能等功能，全面提高施工進度和管理效率，在設計和規劃過程中加強環境分析，提高材料與資源的節約利用水平。2023年，我們已通過地下室管線綜合BIM應用及精裝戶型套內BIM應用兩種場景實現項目的精細化管理。`,
  t314: `本集團高度重視在商業租賃、物業服務、酒店管理和日常辦公等領域的綠色經營管理，完善我們在經營過程中的環境管理體系，加強節能減排、資源節約和廢棄物管理等方面的綠色實踐，助力建設資源節約型和環境友好型社會。`,
  t315: `綠色租賃`,
  t316: `為大力發展綠色租賃、提高可持續商業營運水平，本集團不斷探索綠色商業管理模式，要求所有租賃入駐商戶遵守國家和行業的環境保護政策法規，在租賃期間規範和協助租戶踐行綠色低碳理念，改善節能、節水、減少廢棄物排放等方面的環境表現。`,
  t317: `商戶裝修`,
  t318: `制定《裝修管理作業指導書》，對於商戶裝修期間的能源、水、廢棄物排放、噪音等進行嚴格管控，實現綠色施工。施工單位進場前須簽訂《施工注意事項》，規定施工工期及時間、噪音施工時間，減少及防止施工環境噪音對客人、居民造成影響。施工現場垃圾必須經過包裝後，按要求的路線運至指定的區域堆放，並及時清運到指定的處理場所，確保清運路徑中公共區域的衛生整潔。`,
  t319: `租賃節能管理`,
  t320: `本集團高度重視資源管理，通過合理安排設備設施使用時間等舉措節能減排，利用智能化設備等方式提高水資源使用效率，助力實現綠色低碳營運。`,
  t321: `綠色物業`,
  t322: `本集團持續貫徹落實綠色營運措施，推進物業管理的低碳轉型和可持續發展，打造綠色服務品牌。保利物業、保利（香港）物業在營運管理的過程中承擔環境保護的責任，嚴格遵守環境相關法律法規，踐行綠色營運管理，並已獲得ISO14001環境管理體系認證。`,
  t323: `多晶矽光伏發電項目`,
  t324: `共計421塊光伏電池組，總面積達2,000平方米。在日照穩定的情況下，日綜合發電量約為103千瓦時，年綜合發電量約90,000千瓦時，光伏電池組通過逆變器把光能轉換成電能，併網使用達到綠色使用能源的目的。`,
  t325: `中水站技術改造項目`,
  t326: `針對安寧寧湖峰境小區中水站進行維修和改造，將中水日處理能力由10立方米提升到25立方米以上，有效保障綠化澆水，提高水資源循環利用。`,
  t327: `綠色酒店`,
  t328: `本集團致力於建立健全低碳節約的綠色生態服務體系，不斷提高酒店管理過程中的綠色營運水平。保利商旅採取了一系列環保措施，以減少酒店營運過程中對資源的消耗和對環境的影響，打造綠色酒店，塑造綠色環保的品牌形象，向每一位來酒店的住客傳遞綠色環保理念。`,
  t329: `酒店管理節能舉措`,
  t330: `每月分析能源使用情況，根據各酒店入住率、氣候、節能管理等方面對能源實際發生與預算的偏差進行對比和管控。`,
  t331: `在精益管理方面，各酒店推進常態化節能措施、設備改造等工作，如貴陽酒店對中央空調進行變頻節能改造、對酒店樓層走道裝飾照明燈進行分組控制改造。`,
  t332: `酒店管理節水舉措`,
  t333: `各酒店客房按照設施狀況和維修計劃，陸續更換節水器具。`,
  t334: `公共區域全部更換為節水龍頭。`,
  t335: `餐廳廚房區域嚴格要求節水管理。`,
  t336: `廢棄物舉措`,
  t337: `廣泛宣傳垃圾分類知識，在樓層設置分類垃圾桶。開展月度垃圾分類檢查，及時發現問題並督促整改。`,
  t338: `嚴格控制清潔劑的發放和使用，加強對員工節約意識培訓，提高環保意識。`,
  t339: `施工垃圾嚴格按要求包裝清運處理。`,
  t340: `綠色辦公`,
  t341: `本集團將綠色環保融入我們的經營理念，倡導綠色低碳的辦公方式，鼓勵所有員工積極參與智慧辦公、節能降耗、資源節約、綠色出行等行動，共同創造健康、節約、低碳、環保、舒適的辦公環境，構建環境友好型企業。`,
  t342: `智慧辦公`,
  t343: `不斷完善以OA辦公平台為基礎的審批流程整合，使用電子簽章進行公文處理工作，既提高效率和合規性，也能降低用紙量`,
  t344: `使用文件共享平台同步會議材料，避免會議數據打印，大幅降低會議用紙數量`,
  t345: `進一步推進無紙化辦公的建設，通過在線登記簽字進行高效、規範化管理`,
  t346: `節能降耗`,
  t347: `提倡員工下班時養成隨手關閉辦公室照明燈、空調、電腦等電器設備`,
  t348: `會議結束後及時關閉會議室大屏和照明，及時清理冰箱內已過期物品等。同時，物業兩小時巡樓一次，對節電舉措落實情況進行巡查`,
  t349: `對能耗數據形成常態化收集、分析機制，及時發現異常情況並分析原因、制定整改舉措`,
  t350: `資源節約`,
  t351: `所有洗手間安裝感應水龍頭，智能節水`,
  t352: `提倡員工參加部門內部會議時自帶茶杯茶水，減少瓶裝水的使用量`,
  t353: `優化紙張克重，推行文件雙面打印，降低紙張耗量；在每層複印機間設置廢紙箱，有效利用廢紙、二手紙`,
  t354: `新增辦公區優先使用閒置辦公家具，在降低成本的同時減少裝修污染，保護辦公區生態環境`,
  t355: `綠色出行`,
  t356: `新增公務用車倡導優先採購新能源車，降低碳排放`,
  t357: `重新梳理公務機票、酒店的預定標準，進一步強調標準的嚴格執行`,
  t358: `鼓勵員工乘坐公共交通通勤`,
  t359: `本集團積極響應國家雙碳戰略和綠色生態政策，堅持可持續發展的理念，將綠色投資理念融入公司的戰略規劃和房地產項目的全生命周期。為貫徹落實綠色投資理念，推動土地的良性開發，防止對生態破壞以及保護生物多樣性，我們儘量避免在農田、綠地以及國家的自然保護區中拓展開發項目，並在項目開發過程中積極推動用地整治、生態修復等工作，助力創造美好生活環境。`,
  t360: `貴州公園2010項目`,
  t361: `配建社區公共綠地綠谷公園（紅線外用地整治）`,
  t362: `貴州公園2010項目配建小區公共綠地綠谷公園，整體面積約4萬平方米，原狀為保利置業建設用地之間的荒蕪綠地，植物雜亂，無法供周邊的居民使用。本集團積極承擔社會責任，在保障紅線內住宅建設的同時對建設用地之間的灰空間進行了整治提升，根植於場地本身，融入自然元素，添加生活場景，形成了集公園漫步、兒童樂園、自然課堂、健身運動、聚會交流的公園慢活綠地，為周邊居民提供集中運動休閒場所。`,
  t363: `萬寧保利半島1號`,
  t364: `海岸線生態修復`,
  t365: `海南老爺海岸線生態修復項目位於海南省萬寧市神州半島老爺海（內海）海邊，海岸線長度約500米。保利置業在做好地塊內住宅的同時，積極協同當地政府組織多次凈灘護海行動，逐步清除項目面海區域違建養殖魚排。同時，因地制宜地進行生態恢復及綜合整治工作，將昔日荒蕪地塊轉變成了極具當地度假風情與煙火氣的濱海公園，為當地小區與自然資源整治做出了貢獻。`,
  t366: `海南老爺海岸線（修復前）`,
  t367: `海南老爺海岸線（修復後）`,
  t368: `公益資訊`,
  t378: `2024年中報`,
  t380: `保利置業集團有限公司`,
  t381: `董事`,
  t382: `執行董事`,
  t383: `萬宇清先生（主席）`,
  t384: `胡在新先生（董事總經理）`,
  t385: `非執行董事`,
  t386: `陳育文先生`,
  t387: `獨立非執行董事`,
  t388: `馮志堅先生`,
  t389: `梁秀芬小姐`,
  t390: `黃家倫先生`,
  t391: `吳劍林先生`,
  t392: `董事會委員會`,
  t393: `審核委員會`,
  t394: `提名委員會`,
  t395: `薪酬委員會`,
  t396: `環境、社會及管治委員會`,
  t397: `公司秘書及授權代表`,
  t398: `黃卓謙`,
  t399: `法律顧問`,
  t400: `競天公誠律師事務所有限法律責任合夥`,
  t401: `核數師`,
  t402: `天職香港會計師事務所有限公司`,
  t403: `主要往來銀行`,
  t404: `中國農業銀行股份有限公司`,
  t405: `北京銀行股份有限公司`,
  t406: `中國銀行股份有限公司`,
  t407: `交通銀行股份有限公司`,
  t408: `上海銀行股份有限公司`,
  t409: `中信銀行股份有限公司`,
  t410: `中信銀行（國際）有限公司`,
  t411: `中國建設銀行股份有限公司`,
  t412: `中國光大銀行股份有限公司`,
  t413: `廣發銀行股份有限公司`,
  t414: `招商銀行股份有限公司`,
  t415: `中國民生銀行股份有限公司`,
  t416: `浙商銀行股份有限公司`,
  t417: `招商永隆銀行有限公司`,
  t418: `華夏銀行股份有限公司`,
  t419: `中國工商銀行股份有限公司`,
  t420: `中國工商銀行（亞洲）有限公司`,
  t421: `興業銀行股份有限公司`,
  t422: `馬來亞銀行有限公司`,
  t423: `平安銀行股份有限公司`,
  t424: `中國郵政儲蓄銀行股份有限公司`,
  t425: `上海浦東發展銀行股份有限公司`,
  t426: `股份過戶登記處`,
  t427: `香港中央證券登記有限公司\n香港灣仔皇后大道東183號\n合和中心17樓\n1712–1716室`,
  t428: `註冊辦事處`,
  t429: `香港夏愨道18號\n海富中心一座25樓2503室`,
  t430: `公司網址`,
  t431: `最後更新日期`,
  t432: `年`,
  t433: `月`,
  t434: `日`,
  t435: `本公司就有關董事進行證券交易之行為守則已採納上市規則附錄C3上市發行人董事進行證券交易的標準守則（「標準守則」）。於企業管治報告期間內，全體董事已妥為遵守標準守則。`,
  t436: `組織章程細則`,
  t437: `董事名單與其角色和職能`,
  t438: `職權範圍`,
  t439: `審核委員會`,
  t440: `薪酬委員會`,
  t441: `提名委員會`,
  t442: `主要附屬公司董事名單`,
  t443: `年主要附屬公司董事名單`,
  t444: `主席及董事總經理之職責分工`,
  t445: `舉報政策`,
  t446: `股東提名人選參選董事的程序`,
  t447: `股東通訊政策`,
  t448: `股東權利`,
  t449: `補發遺失股分證明書`,
  t450: `根據香港《公司條例》有關補發已遺失的上市公司股分證明書之公告`,
  t451: `擬發出新股份證明書的公告`,
  t452: `有關取消原有股份證明書及發出新股份證明書的公告`,
  t453: `點擊查看`,
  t454: `傳真`,
  t455: `投資者/傳媒查詢`,
  t456: `廉政信訪舉報`,
  t457: `舉報`,
  t458: `信訪`,
  t459: `舉報政策`,
  t465: `負責任供應鏈`,
  t466: `踐行社會責任`,
  t467: `本集團制定了供應鏈全生命周期管理流程，通過在供應商准入及管理環節將 ESG 因素納入考慮，加強負責任供應鏈管理與可持續採購管理，共同促進價值鏈的可持續發展。`,
  t468: `供應商管理體系`,
  t469: `本集團嚴格遵守《中華人民共和國招標投標法》《中華人民共和國招標投標法實施條例》《中華人民共和國政府採購法》等法律法規，制定《保利置業集團招標管理制度》《保利置業集團供方管理制度》《保利置業集團集中採購供方管理辦法》等內部管理制度。通過制度明確供應商引入、評估、分級管理等全生命周期的管理行為及流程，構建供應鏈「選、用、育、評」的動態管理機制。`,
  t470: `供應商引入`,
  t471: `針對不同類別的供應商，我們設立了專項入庫考察標準，從資質、產品、質量、標杆業績等多方面篩選合格供應商，打造優質供應商庫。`,
  t472: `供應商評價`,
  t473: `在前期設計配合、合同簽訂、施工（或排產供貨）、驗收及售後服務等各個階段，我們對供應商進行全面評價，以促進其履約能力的提升和服務質量的提高，同時優化供方的管理水平。`,
  t474: `供應商分級管理`,
  t475: `激勵機制`,
  t476: `針對評價為「優秀」的供應商，我們採取獎勵措施，以表彰其卓越表現。`,
  t477: `退出機制`,
  t478: `對於評價為「不合格」的供應商，我們執行退出機制，不斷優化供應商資源庫，確保供應鏈的整體質量。`,
  t479: `可持續採購`,
  t480: `我們將勞工準則、職業健康與安全、產品質量、環境保護、反貪腐與商業道德等ESG 指標納入供應商准入和評估的考察範圍，確保採購的合規性，降低供應鏈風險，積極推進可持續採購的踐行。`,
  t481: `供應商ESG管理`,
  t482: `本集團制定並向供應商宣貫《保利置業集團供應商行為準則》，要求供應商簽署《遵守保利置業集團供應商行為準則的承諾書》，將ESG 理念延伸至供應鏈上下游各環節，提升供應商的可持續發展表現。我們在供應商引入階段設置ESG 考慮，要求供應商提供管理體系認證，包括但不限於信用等級證書、質量管理體系、環境管理體系、職業健康與安全管理體系等ESG 管理相關認證證書。我們通過供應商約談、調研、巡檢等方式，對供應商現狀、管理制度、操作流程、評估獎罰等方面開展供應商梳理工作，加強供應商管理和社會責任等方面的評估分析和可持續能力建設。`,
  t483: `廉潔管理`,
  t484: `綠色採購`,
  t485: `我們踐行綠色採購理念，優先採購具有可持續認證、低消耗、低能耗、無污染、多功能的綠色產品，引導供應商主動提高產品質量和環保性能，持續降低可能造成的環保風險，推動全產業鏈的綠色發展。`,
  t486: `溝通與培訓`,
  t487: `本集團重視和供應商的溝通與交流，持續維繫良好的合作關係，積極為供應商提供支持與幫助。我們通過多種溝通渠道，圍繞質量、健康與安全、可持續發展等方面與供應商及時溝通，積極開展供應商培訓和整改，幫助供應商加強能力建設，實現合作共贏。`,
  t488: `「築城築信，共築美好」 供應商大會`,
  t489: `為進一步強化與供應商的溝通互信，深化質量意識和履約精神，保利置業上海公司於2024 年1 月舉辦了「築城築信，共築美好」為主題的2023 年度供應商大會，宣貫工程、成本、設計條線的管控要求，對優秀供應商進行表彰，實現與供應商的深入交流、攜手並進、合作共贏。`,
  t490: `保利少年志`,
  t491: `2021年，保利置業正式啟動保利少年志公益活動。帶領9名大山少年飛躍大山，圓夢北京之旅，並在貴州冊亨縣學校捐建"保利藝術教室""保利夢想圖書室"。2022年，開展"保利少年志·千里課堂"，全國11位夢想導師跋涉9300餘公里，為66名大山孩子帶來人文、藝術、理想啟蒙課程。2023年，首次聯動"保利星火教育金"，在全國7個定點幫扶縣設置"保利少年志·星火教育金"，共捐贈210萬元、覆蓋1289名師生，鞏固脫貧攻堅成果，夯實人才振興、文化振興的重要基石。`,
  t492: `社區回饋`,
  t493: `本集團致力於為社區創造價值，注重與小區居民建立緊密的聯繫，了解他們的需求和期望，並提供相應的支持和幫助。同時，我們也鼓勵員工積極參與社區回饋活動，培養他們的社會責任感和公民意識。`,
  t494: `「學習二十大 志願新征程」學雷鋒青年志願服務活動`,
  t495: `2023年3月，保利置業上海公司組織開展「學習二十大志願新征程」學雷鋒青年志願服務活動。青年志願者們前往福利院為老人提供慰問與慰問品，在減少老人的孤獨感，提升老人幸福感的同時進一步弘揚「奉獻、友愛、互助、進步」的志願精神。`,
  t496: `第六屆「為孤獨症行走」大型公益徒步活動`,
  t497: `2023年4月，保利置業江蘇公司聯合太陽花兒童服務中心等機構舉辦以「點亮星空，愛不孤獨」為主題的第六屆「為孤獨症行走」公益徒步活動。本次活動深化了公益品牌建設，提高社會對孤獨症群體的關注度，助力他們更好地融入社會。`,
  t498: `「鑄牢中華民族共同體意識」主題團日活動暨少數民族青少年「手拉手」`,
  t499: `2023年，保利置業廣西公司團員和少數民族青年員工參觀民族村，體驗廣西的多元文化，向小學生宣傳民族團結教育，增強團員青年的民族文化自信和愛國情懷，引導青少年增強文化認同和民族團結意識。`,
  t500: `「全民國家安全教育日」宣傳志願服務活動`,
  t501: `2023年4月，在「保利樂跑中國」廣西站活動中，我們別出心裁地組織了「國家安全知識飛盤趣味競答」，以輕鬆有趣的方式向業主、員工及公眾傳遞國家安全知識。此舉在全民國家安全教育日之際，有效地提升大家對國家安全的認識，增強全民維護國家安全的共識。`,
  t502: `保利物業「「衣」愛之名，助力公益」家庭閒置衣物捐贈循環利用公益活動`,
  t503: `2023年，保利置業江蘇公司攜手愛心業主，開展「「衣」愛之名，助力公益」家庭閒置衣物捐贈循環利用公益活動，向貧困山區孩子們傳遞溫暖與愛意。`,
  t504: `義工行動`,
  t505: `本集團積極參與美好小區的建設，開展義工活動。在義工行動中，本集團志願者們深入小區，用實際行動踐行企業社會責任，讓更多的人感受到企業的關懷和幫助。`,
  t506: `助力集士港賣面橋村老年活動中心建設`,
  t507: `2023年2月，保利置業浙江公司赴賣面橋村老年活動中心進行捐贈活動，為老年活動中心送去健身設備、娛樂設施、空氣凈化器等物品。`,
  t508: `「3.12」義務植樹志願服務活動`,
  t509: `2023年3月，我們積極開展義務植樹志願服務活動，進一步增強員工環保意識，踐行綠色發展理念，為生態文明建設貢獻「保利力量」。`,
  t510: `「守護昆明冬日小精靈」護鷗行動`,
  t511: `2023年，保利置業雲南公司在昆明海埂開展「守護昆明冬日小精靈」護鷗行動，各部門團員青年代表參加本次主題活動。志願者們主動向市民、遊客宣傳科普保護紅嘴鷗的相關知識，提高廣大市民、遊客愛鷗護鷗意識。`,
  t512: `「志願服務進工地」慰問農民工活動`,
  t513: `2023年3月，保利置業貴州公司開展「志願服務進工地」慰問農民工活動。通過發動青年志願者服務隊走進工地，為辛勤勞作的工人們送去熱騰騰的午餐，並在用餐的間隙宣傳預防甲流的方法和措施。`,
  t514: `「生活讀享季 書香進社區」公益活動`,
  t515: `2023年4月，保利置業廣東公司舉行「生活讀享季 書香進小區」公益活動，向全小區廣大群眾發出愛讀書、讀好書、善讀書的號召。本次公益活動為期一個月，捐贈各類書籍共400 余冊，同時在小區黨群服務中心設立「文化驛站」，定期安排公司志願者在現場開展志願服務，健全現代公共文化服務體系。`,
  t520: `精美產品`,
  t521: `精心服務`,
  t522: `客戶權益`,
  t523: `保利置業秉承"追求極致產品和服務質量" 匠心精神，在"保利是吾鄉"全新品牌發展觀的引領下，以"至真·致美·置吾鄉" 的全新產品品牌，承接使命願景，指導產品精神，連結客戶感知，打造具有卓越競爭力的品牌生態鏈。`,
  t524: `POLYLIGHT\n人居四感體系`,
  t525: `打造夯實的產品價值底盤，既貫徹了以客戶為中心，觸達業主真正居住需求的產品理念，又起到了產品細節落地過程中的嚴格品控作用，為項目提供高質量的技術模塊和指引規範。`,
  t526: `致美生活圖譜`,
  t527: `以聚焦市場新趨勢和客戶新需求的視野，在產品力精進的道路上實現產品體系的持續疊新。以「甲第系、譽系、賦系、印系、壹號系」五條產品線，為每類客戶提供專屬的美好生活方式。`,
  t528: `甲第系`,
  t529: `稀貴顯赫藏品`,
  t530: `坐擁城市珍稀資源，\n雕琢不可複製的藏品之作。\n為極少數定製\n以身份和品位的非凡象徵，\n標定人生高度。`,
  t531: `譽系`,
  t532: `高定藝術瑰品`,
  t533: `接軌國際的臻美定製，\n輝映時代風華。\n以城市高階生活的質量引領，\n兌現極致風範。`,
  t534: `賦系`,
  t535: `厚韻傳著之作`,
  t536: `為城市賦以精神意象，\n以文化傳着\n以設計言志。\n溯源東方人文精神，\n探尋人文華宅的當代表達。`,
  t537: `印系`,
  t538: `靈感心造之作`,
  t539: `斂藏時光豐盛\n印見煙火生活日常。\n以有溫度有格調的質量居所，\n書寫家的溫情美好。`,
  t540: `壹號系`,
  t541: `山水棲心之作`,
  t542: `得天獨厚的天賦資源下，\n構築宜居家園。\n以遼闊的天地滋養\n創造生命的共振與連接。`,
  t543: `煥新智慧家園`,
  t544: `引進先進的智能化設備，全面提升公共系統，打造智慧化住宅和社區，以高質量、高標準、高科技、高品位煥新智能化人居體驗新高度。`,
  t545: `打造智慧社區`,
  t546: `保利置業在深圳保利龍譽、保利雍山郡、保利明玥瀾岸花園和靜安府等項目中，創新打造智慧社區（智慧出行、智慧安全、智慧設施、智慧服務）、共享社區、綠色社區、無憂社區、室內增值共五大模塊，並在此基礎上增設「歸家體驗」的升級模塊。\n\n在創意樣板房引入智能家居提升項，展示智能中控屏、智能燈控系統、電動窗簾電機等智能設備，提供了良好的場景氛圍。在大區設計中，配備了智能車牌識別、人臉識別門口機、高空拋物監控、車庫一氧化碳濃度檢測、智能門鎖、戶內可視對講等設備，打造人行車行的無感通行，營造智能、低耗、節能、健康、便捷的智慧之家。`,
  t547: `智能中控系統`,
  t548: `保利置業在山東保利瓏譽項目上採用可視對講兼智能中控系統。戶內10.1寸中控屏，既是可視對講室內機，也作為全屋智能控制終端，併兼具語音識別功能，實現全屋智能設備語音控制。\n\n該項目還引入了智能照明系統，根據場景模式開閉不同燈光，營造不同居家氛圍，滿足不同生活場景。業主可以通過智慧生活APP輕鬆遠程控制客餐廳的所有燈具，實現便捷的智能管理。\n\n此外，為方便老人使用，客餐廳所有燈光均可實現牆面開關、中控屏、語音等方式控制，確保他們能夠更加自如地操作。`,
  t549: `保利置業始終以客戶價值戰略為導向，致力於為客戶提供專業、溫暖且高效的服務，共同創造美好生活`,
  t550: `物業管理`,
  t551: `保利物業始終以品質為先，秉承「讓生活更美好」的服務理念，構建「人+物+時間」結合的服務模式，形成「空間+ 時間」的服務特點，利用「智能化」科技手段，着力打造安全與安心並行的全方位服務體系。2023 年，保利物業、保利（香港）物業均已通過ISO9001質量管理體系認證。`,
  t552: `保利物業為客戶提供高端定製化服務，堅持全時態的服務標準，為客戶提供始終如一的高質量服務。`,
  t553: `高端定製服務`,
  t554: `依據業主群層和客群的特點，深入探究和發掘業戶對於質量生活的個性化需求，圍繞業戶生活的「衣、食、住、行、康健」育兒、養生、社交等需求，提供定製化服務，實現隨需而動的尊崇體驗。`,
  t555: `專屬服務`,
  t556: `為新收樓的業戶提供禮遇新禧交付服務。為每一戶收房的業主舉辦一個小型、簡短、隆重的金鑰匙交房儀式。`,
  t557: `服務標準`,
  t558: `365天、24小時的全時態、不間斷服務，30分鐘快速響應，始終關注守護客戶的安全。專屬管家服務，隨需而動，始終關注客戶的所需所想，讓尊崇體驗不間斷。`,
  t559: `酒店服務`,
  t560: `保利商旅為本集團旗下的酒店管理平台，負責自營酒店項目的經營管理及新項目受託管理開發等。\n保利商旅聚焦全周期客戶體驗，主要以客戶信息管理、客戶關係管理維護、客戶滿意度調查等方式為主，並根據客戶投訴制定行動解決方案，不斷提升酒店服務管理水平，讓每一位顧客賓至如歸。`,
  t561: `保利置業致力於全方位保障客戶權益，通過嚴密的私隱保護機制、高效的投訴處理和合規的營銷行為，為客戶提供安全可靠的服務體驗。`,
  t562: `客戶滿意度`,
  t563: `保利置業持續開展客戶滿意度調研。各區域通過小區煥新、維修增值等各類觸點行動增強業主粘性，客戶滿意度整體呈正反饋。2023年集團總體滿意度較2022年提升12%。`,
  t564: `客戶訴求響應`,
  t565: `搭建了多渠道客戶溝通和投訴機制，涵蓋400呼叫中心、微信公眾號、客服、管家企業微信、房修等。2023年，本集團400呼叫中心團隊迭代升級，立足於高效處理各階段業主報事報修及要求服務，年度7*10h無休接聽，為客戶提供更加系統和全面服務。2023年集團客戶投訴處理率98%。`,
  t566: `負責任營銷`,
  t567: `保利置業嚴格遵守《中華人民共和國廣告法》《商品房銷售管理辦法》等法律法規，並建立了《保利置業集團有限公司營銷管理制度》等內部管理制度，切實踐行合規營銷，確保宣傳物料的真實可靠。`,
  t568: `2023年，本集團加強營銷廉政建設，持續深化營銷風控意識，共抽查了65項營銷業務，並對相關320 項流程進行巡檢和評審。`,
  t569: `信息安全及私隱保護`,
  t570: `本集團嚴格遵守《中華人民共和國個人信息保護法》《中華人民共和國數據安全法》《中華人民共和國網絡安全法》等法律法規，建立了完善的數據安全管理體系，全方位保護客戶信息安全。通過及時管控信息安全風險，不斷提升本集團的信息安全等級，保障客戶合法權益不受侵害。`,
  t571: `通過微信小程序、APP等端口向客戶提供多元化服務，所有客戶行為數據的獲取都需要客戶同意簽署《數據私隱協議》。`,
  t572: `嚴格執行數據安全備份管理`,
  t573: `嚴格落實數據安全備份管理，數據在正式上線前，應用系統負責人必須提交數據庫和附件的備份策略和備份腳本，並完成本地備份。同時，對於應用系統數據庫備份周期及保留時長進行嚴格要求。`,
  t574: `數據脫敏處理`,
  t575: `在數據的管理與運用過程中，均做到客戶手機號、身份信息的脫敏處理，避免項目一般人員接觸到敏感數據。同時，在數據在傳輸過程中也進行了數據加密碼處理。定期進行數據安全相關法律知識的培訓。`,
  t576: `系統分級權限控制`,
  t577: `處理數據時嚴格遵循數據管理流程，分為申請、審批、轉發、修改、檢查、啟用六大步驟。\n24小時不間斷監控監控數據文件的備份、保存與歸檔、保密等工作。`,
  t578: `數據運維安全管理機制`,
  t579: `伺服器或數據的運維都需建立在安全的運維鏈路上。\n對於所有訪問系統的行為，均作日誌記錄。`,
  t580: `CRM系統本地化部署`,
  t581: `CRM 系統完成本地化部署，數據安全性得到全面提升。`,
  t591: `2024年中報`,
  t593: `保利置業集團有限公司`,
  t594: `集團要聞`,
  t595: `媒體聚焦`,
  t596: `多媒體中心`,
  t598: `關注保利置業`,
  t608: `人才發展`,
  t609: `人才理念`,
  t611: `人才培養`,
  t612: `人才招聘`,
  t613: `德才兼備 以德為先`,
  t614: `堅持"德才兼備、以德為先"的人才標準，推行"責任心、綜合素質、專業能力"的人才評價排序，從政治素養、自我領導力、團隊領導力、業務領導力四個維度出發，構建"1+6"保利置業領導力素質模型，統一人才共識。`,
  t615: `知行合一`,
  t616: `秉承"明理 、篤行、 善進"與"知行合一"的人才觀，讓每一位保利置業人知行合一、把握大勢、按規矩辦事，保持戰略定力，持續精進，實現個人價值與社會價值的統一。`,
  t617: `明理`,
  t618: `，明辨是非，把握大勢。`,
  t619: `篤行`,
  t620: `，堅定信念，踐履所學。`,
  t621: `善進`,
  t622: `，積極進取，勇毅前行。`,
  t623: `明理而篤行，篤行而善進`,
  t624: `以知促行、以行促進，助力保利置業高質量發展。`,
  t630: `崗位名稱`,
  t631: `所屬機構`,
  t632: `工作地點`,
  t633: `黨務管理（校招）`,
  t634: `集團總部`,
  t635: `上海`,
  t636: `崗位職責：`,
  t637: `1、負責保利置業基層黨組織建設工作，並配合黨委辦公室開展相關工作。`,
  t638: `崗位要求：`,
  t639: `1、中共黨員；
2、應屆生碩士研究生及以上學歷；
3、具備國、央企黨務工作經驗者優先；
4、工作認真細心，責任心強，性格開朗，具有較強文字能力，組織和溝通協調能力。`,
  t640: `投遞郵箱：`,
  t641: `新聞宣傳（校招）`,
  t642: `1、負責保利置業新聞宣傳及輿情管理相關工作。`,
  t643: `1、中共黨員；
2、應屆生碩士研究生及以上學歷，新聞傳播、漢語言文學、中文等相關專業優先；
3、具備紮實的文字功底和寫作能力，了解國央企新聞傳播特點，有較強的新聞敏感性，公眾號編輯能力和創新意識，具備選題、活動策劃和新聞宣傳整合和執行能力；
4、熟練掌握視頻編輯技能、有互聯網平台內容製作崗位或運營崗位經歷者優先。`,
  t644: `數字天軍`,
  t645: `1. 根據公司業務發展，負責房地產營銷數碼化創新業務規劃的路徑分解和實施落地；
2.負責創新業務模式的探索、落地及其他相關日常工作相關，如業務需求的溝通協調、業務梳理，推動項目落地；
3.負責創新業務模式的建立和運營陪跑論證；
4.負責實施過程中的項目管理，推進軟件產品的開發、實施、上線和運維，確保產品品質；
5. 輔助創新模式下的營銷體系變革支持與協調；
6. 識別總體業務需求，注重橫向協作，解決過程中遇到的問題，疑難雜症。`,
  t646: `1、全日制本科及以上學歷，5年以上數碼化或營銷類業務創新經驗者優先；
2.對企業數碼化轉型相關領域有足夠認知洞察能力，並能前瞻性地理解技術發展趨勢和應用場景，結合公司情況進行實踐探究；
3.對線上營銷有深刻認知，具備相關項目成功經驗者；
4.對產品創新、業務創新、業務運營有一定的見解，善於解題答題；
5.具備良好的數據分析能力，對數字型數據較為敏感。`,
  t647: `機電設計`,
  t648: `1.負責公司機電條線設計管理工作，負責區域機電設計方案審核工作；
2.負責專業標準化及創新研發工作；
3.負責建立與完善專業制度標準工作，包括工作流程、管理制度；
4.負責設計資源的拓展與管理，管理設計供應商庫，完善供應商管理制度、評價流程；
5.協助集采的選型定樣，完善集采品類、規範定樣標準等。`,
  t649: `1.本科及以上學歷，電氣專業背景，熟悉水暖電全專業相關知識。
2.品質房企集團或500億體量區域經驗優先；
3.具備條線體系管控經驗，包括且不限於資源庫搭建、條線培訓、考核、標準化、創新研發等工作。
4.5年以上住宅設計管理經驗，具有高端住宅/公建機電管理經驗。熟悉國家及地區設計相關管理制度及技術規範；有較強的專業設計和技術管理能力，有較強的邏輯思維；
5.認真負責，主動思考，具有創新精神；有較強的橫縱向溝通協調能力，具有團隊精神，能夠承擔較大的工作壓力和挑戰。`,
  t650: `戰略研究`,
  t651: `1.跟蹤研究行業市場、政策、土地，對行業走勢形成全面跟蹤，對趨勢做好預測，把握周期的風險和機遇，指導投資策略的擬訂，投資標準和原則的優化；
2.跟蹤研究競企的經營策略、城市佈局策略、投資策略，挖掘可以借鑑的重要信息；
3.研究擬定公司投資策略，開展區域、城市及板塊投資佈局分析；
4.完成代建、商業、自持租賃住宅等相關專題研究工作；
5.配合上級單位和集團總部，完成佈置和協同的相關研究工作；
6.配合投資管理和拓展的相關工作。`,
  t652: `1.年齡40歲以下，工程管理、管理科學與工程、房地產與土地管理、技術經濟及管理、金融相關專業優先；
2.系統掌握房地產市場分析的方法論，有豐富的研究經驗；
3.工作認真仔細、責任心強，能夠快速適應工作環境帶來的全新挑戰，具有一定的抗壓能力；
4.標杆房企相關崗位或標杆乙方智庫5年以上，有投資拓展工作經驗優先。`,
  t659: `建立"睿見、睿知、睿才"三級人才培養計劃
致力於打造從優秀到卓越的管理人才梯隊`,
  t660: `優秀管理者`,
  t661: `聚焦專業度、關注專業管理能力，旨在培養強執行、擅協作、能成事的優秀高潛（未來）管理之才。`,
  t662: `專業經營者`,
  t663: `聚焦經營思維，關注運營能力，旨在培養善思明智、懂經營會管理的專業經營之才。`,
  t664: `卓越領導者`,
  t665: `聚焦組織能力、幹部人才梯隊建設、企業文化塑造，旨在培養能夠引領組織、達成業績、創造價值、創新變革的卓越之才。`,
  t666: `從優秀到卓越的管理團隊`,
  t667: `卓越科技
與健康同行`,
  t668: `全國標準`,
  t669: `項`,
  t670: `行業標準`,
  t671: `國家專利`,
  t672: `餘項`,
  t673: `高新技術企業評為`,
  t674: `次`,
  t675: `保利星 保利微芯`,
  t676: `北京保利星數據光盤有限公司由保利置業集團有限公司、保利國際控股有限公司共同投資，於1999年7月成立。保利星是國家新聞出版總署認定的首批《國家光盤複製示範企業》，是全國光盤複製企業中唯一一個連續獲得五屆印刷複製獎的企業。先後制定國家標準3項、行業標準20項，獲得國家專利10餘項。自2001年起至今連續七次被評為高新技術企業。`,
  t677: `2019年8月保利星公司將微流控晶片業務剝離，由保利置業集團有限公司投資成立了北京保利微芯科技有限公司。憑藉在微流控晶片設計領域的技術積累和創新實力，保利微芯成功被認定為國家級高新技術企業、北京市專精特新中小企業。產品實現了用於循環腫瘤細胞捕獲、單細胞捕獲、微液滴生成檢測、單細胞微珠液滴等微流控晶片產品，實現對國外產品的替代，達到國際同等水平。目前已取得專利8件，其中發明專利4件。通過ISO13485醫療器械行業質量管理體系認證。與北京工業大學共建了"產學研聯合培養研究生基地"。`,
  t678: `境內外高端房地產開發`,
  t679: `保利置業深刻學習領會中央重大戰略部署，深耕長江經濟帶、粵港澳大灣區、環渤海經濟帶以及西南和東北面向東盟、東北亞開放戰略核心區，精築中國三十城，業務遍及上海、北京、香港、廣州、深圳、杭州、重慶、武漢、濟南、哈爾濱、貴陽、南寧、昆明、蘇州、寧波、佛山、煙臺、萬寧等城市，開發投資近200個項目，為60萬中國家庭、200萬中國人實現安居夢想，先後投資開發北京新保利大廈、北京保利大廈、上海保利廣場、上海證券大廈、上海保利大劇院、廣州中信廣場、武漢保利廣場等城市地標建築，已成為城市名片。`,
  t680: `個`,
  t681: `項目`,
  t682: `萬`,
  t683: `中國家庭`,
  t684: `中國人`,
  t685: `掃一掃,關注保利置業`,
  t686: `上海保利廣場`,
  t687: `上海保利廣場是保利置業在上海的旗艦項目和總部辦公區，佔有極為稀缺的黃浦江觀景資源和上海金融中心功能區的區域資源，由雙塔蝶形主樓、四棟鑽石切割狀的獨棟辦公樓和四個下沉式廣場組成，創陸家嘴辦公樓層高之最。`,
  t688: `北京新保利大廈`,
  t689: `位於北京市東城區東四十條橋西南角，於2007年開盤，是集高檔寫字樓、博物館及商業娛樂設施於一體的綠色智能化大廈，被譽為"北京新地標"。擁有以搶救圓明園國寶而聞名的保利藝術博物館，與保利大廈和保利劇院遙相呼應，成為北京一處重要的文化景觀。`,
  t690: `北京保利大廈`,
  t691: `保利大廈酒店於1992年正式成立，是一座集客房、寫字樓、劇院、餐飲、娛樂、會議設施為一體的綜合型四星級商務酒店，1997年被國家旅遊局評為"中國旅遊行業標誌性建築"，已通過ISO9001質量體系認證，獲得"北京市優秀物業管理大廈"和"北京晚間優秀活動場所"的稱號，2003年被中國飯店協會評定為5A級"中國綠色飯店"。`,
  t692: `上海保利大劇院`,
  t693: `坐落於上海市嘉定新城中心區，面向生態美境遠香湖，建築面積達5.6萬平方米，總投資約7億人民幣，由享譽世界的建築大師安藤忠雄擔綱設計，上海保利大劇院揉匯了國際尖端建築潮流與傳統人文美學精神，營造出一個自然、建築、藝術、人類彼此和諧相容、自在對話的公共藝術交流空間。`,
  t694: `廣州中信廣場`,
  t695: `廣州中信廣場位於中國廣州市天河區商業、金融業繁華的天河北路，佔地2.3萬平方米，總建築面積29萬平方米，1997年建成時為當時中國的最高建築，也是世界上最高的混凝土大廈。它面向天河體育中心，背後是廣州火車東站和廣州地下鐵總站，地理位置優越，擁有辦公商住環境，落成不久即廣州的標誌性建築之一，是很多全球500強公司在廣州的辦公地點。`,
  t696: `深圳保利文化廣場`,
  t697: `深圳市保利文化廣場是中國保利集團首個"文化商業地產"項目，於2004年9月3日舉行奠基儀式，2007年12月31日保利劇院完成首場演出，2008年3月8日項目全面開業。地處南山城市雙中心發展的西部濱海CBD－深圳灣後海商圈，是集特色餐飲、零售百貨、文化娛樂、休閒體驗類業態的大型綜合商業中心。`,
  t698: `上海證券大廈`,
  t699: `上海證券大廈位於浦東陸家嘴金融貿易區中心，由中國保利集團和上海證券交易所聯合投資，總投資逾1.2億美元。上海證券大廈3600平方米的交易大廳，是目前亞太地區最大的無柱交易大廳，場內長32米、高4米的電子顯示屏也稱亞洲之最。`,
  t700: `武漢保利廣場`,
  t701: `武漢保利廣場為中國保利集團繼北京保利大廈、北京新保利大廈、廣州中信廣場、上海證券大廈等建築之後，在華中地區斥巨資打造的"同系力作"。位於武漢內環核心、華中金融城主軸、湖北省政治文化，傲據水果湖政務圈、中南商圈、東湖生態圈三大絕版區域黃金分割點，中心以211.8米的高度俯瞰武漢三鎮。`,
  t702: `人居四感體系`,
  t703: `第1重價值坐標-美學質感`,
  t704: `從大空間到小細節，從表象到內里，全盤全維考究中，雕琢產品美學質感，跨越東西方的審美傳承。`,
  t705: `第2重價值坐標-環境適感`,
  t706: `以低碳綠色建築編織更綠色的城市生活，藉助智慧科技力量打造居家場景，人性化的全場景築底。`,
  t707: `第3重價值坐標-關係靈感`,
  t708: `從社區外繽紛煙火到社區內多元互動，在激發空間互動能量中，找到舒適愉悅的理想關係。`,
  t709: `第4重價值坐標-精神情感`,
  t710: `從關鍵觸點守護、愉悅時光共鑒、高階服務預設、幸福傳遞領創等維度，譜寫致美 生活圖譜。`,
  t711: `面對多元化美好訴求，保利置業以"甲第"、"譽"、"賦"、"印"、"壹號"五大產品系去回應，從城市到山海，覆蓋國際與東方，這五條產品系共同譜寫了保利置業的致美生活圖譜,拓寬當代美好人居的豐盛圖景，提供更為和諧的安居嚮往之地。`,
  t712: `點擊放大`,
  t713: `稀貴顯赫藏品`,
  t714: `耀世矚目的尊貴象徵`,
  t715: `蘇州紫金·翡麗甲第`,
  t716: `中國保利集團& 金隅地產雙鉅合著,蘇州首座"甲第"系作品，劃界蘇州豪宅新時代。擇址湖東核心精粹金雞湖 CBD 重量級資源配套，同源國際生活範式，承襲保利"甲第"系高端豪宅基因，融匯千年姑蘇底蘊與世界審美,以世界級傳奇酒店為靈感藍本,境呈酒店式藝術奢雅園境。以穿越時間周期的璀璨藏品,致敬蘇州塔尖圈層傾賞。`,
  t717: `上海保利·翡麗甲第`,
  t718: `上海保利·翡麗甲第：作為保利置業上海濱江豪宅封面之作，項目 2015 年底開盤銷售,入市便受到了市場的青睞，並取得 2016 年楊浦區商品住房銷冠，成為楊浦區豪宅典範。產品打造以東方居住哲學，融會西方建築精粹;在室內空間的打造上，兼顧優雅與功能，通過對居家生態、智能體系、定製車位等多維度的精工雕琢,使得楊浦區新建商品住宅在文化人居體驗上有了顯著提升。`,
  t719: `高定藝術瑰品`,
  t720: `引領時代的高階享受`,
  t721: `廣州保利琅譽`,
  t722: `保利琅譽，保利置業打造的第九座「譽」字系高端產品，擇址番禺區府新城，位於"番禺廣場"與"番禺客運站"雙TOD上，集高濃度、高品質的城市精粹為一體，交通便捷，番禺永旺夢樂城、基盛萬科里等城市級商圈環伺，幼兒園就在家下，廣外附小及仲元中學在側；未來，居住於此，時刻感受生活的美好與豐盈。`,
  t723: `濟南保利瓏譽`,
  t724: `濟南保利瓏譽，約26萬方大體量高端住宅項目，雄據CBD中環，觀臻"山泉湖河城"城市天際線，近享茂嶺山、綢帶公園自然美景，集萃CBD萬千繁華，優質商業、醫療、交通、教育等配套資源環伺。主城稀有綠建三星標準住宅，社區配置超1600㎡殿堂級會所，書寫城市奢享人居範本。`,
  t725: `香港保利龍譽`,
  t726: `項目傲據香港啟德發展區優越位置，前臨啟德郵輪碼頭及維多利亞港，迅步可達港鐵啟德站，穿梭港九新界，盡享未來落成沙中線交通優勢及啟德區生活之配套便利。尊尚住客會所「THEVIBE」設計簡約時尚，總面積約3萬5千平方，提供逾32項室內戶外設施, 是香港啟德九龍核心區盛譽之作。`,
  t727: `厚韻傳著之作`,
  t728: `精粹的人文體驗`,
  t729: `蘇州保利尚雲賦`,
  t730: `保利置業賦系首作，位於蘇州崑山國際經開，在世界看東方的趨勢之下，通過建築、文化、圈層的賦新，賦寫東方大國的文化自信。項目特邀大師團隊,以低密隱奢為基礎，人居四感體系為框架，構築東方人文精奢大平墅。以純粹圈層場域，為時代所序。感受自然，體驗東方美學園林的深遠意境和生活哲學。`,
  t731: `蘇州保利珺華賦`,
  t732: `高端改善賦系第三子，落址蘇州工業園區獨墅湖高教區之上，高校環伺、智企匯聚；約2KM獨墅湖邊，五大生態公園環繞，集萃園區商業、教育、自然、人文等精華資源。以江南文化為底蘊，師法全球頂奢酒店安縵系，輔以全球臻材奢石，全冠移植黑松&羽毛楓等珍植，以高定私人會所為核心、匠築約152-222㎡文化奢宅。`,
  t733: `濟南保利鵲華賦`,
  t734: `高奢賦系濟南首作，特邀五位國際設計大師合著，以約6000畝圍子山半山為勢，打造1.2容積率低密峯境，4-8層約165-240㎡浮島洋房，4層約220-350㎡高定隱墅，社區內享萬平青山景觀，約1300㎡美學會所，呈映東方雅奢墅居。`,
  t735: `靈感心造之作`,
  t736: `寵悅自我的豐盛獲得`,
  t737: `廣州保利錦上印`,
  t738: `保利錦上印依託2條花地灣濱水景觀資源,規劃耗資千億120萬㎡東漖舊改項目"2+8"生態升級系統煥新城市面貌,配建約40萬㎡公園式濱水商業群落,滿足吃喝玩樂、娛樂休閒等需求。項目內規劃約1.8萬㎡"安縵系"園林,匠築六大精奢空間,一館十二泛會所,豐富業主圈層鄰里生活,定義廣府低密品質人居新標準。`,
  t739: `南寧保利宸上印`,
  t740: `項目位踞主城一環核心，秀廂大道中央，盡匯學鐵商園全維優質資源，脈承"印"系高端產品基因，匠造主城難得約3.0低密舒居。在戶型設計上享約100%得房率，高性價比入階主城熱土，是全國第五座印系著作。`,
  t741: `山水棲心之作`,
  t742: `自在歸心的山海沉浸`,
  t743: `萬寧保利·半島壹號`,
  t744: `項目，保利置業的自然旅居傑作，擇址海南萬寧老爺海度假生活區。項目獨攬內外雙海資源，依託約1.6公裏海岸線，採用山、居、岸、海的整體規劃理念，打造完美視覺與海洋內涵的度假住區，創享多元沉浸式的度假體驗。`,
  t745: `鑄就高品質物業服務`,
  t746: `締造全周期美好生活`,
  t747: `保利物業 美好服務`,
  t748: `上海保利物業酒店管理集團有限公司（以下簡稱保利物業）於1996年在北京成立，隸屬於保利置業集團，作為首批國家一級資質物業，保利物業率先將星級酒店服務品質融入物業服務，致力為業主創造安全、舒適、溫馨的人居環境。自1997年保利物業第一個大型涉外別墅項目北京麗京花園起，保利物業以日益精益的服務打造出上海翡麗甲第、上海證券大廈、廣州中信廣場、北京新保利大廈等標杆項目，見證着城市蓬勃發展的浪潮，截止2024年6月30日，進駐全國41個城市，服務321個項目，與近百萬業主共創美好生活。`,
  t749: `旗下業務`,
  t750: `住宅`,
  t751: `商寫`,
  t752: `城市`,
  t753: `多元`,
  t754: `住宅服務`,
  t755: `全時服務，深度關懷`,
  t756: `始終以業戶的精細需求和全面尊重為核心`,
  t757: `瀏覽網站`,
  t758: `商寫服務`,
  t759: `高標服務，高效管理`,
  t760: `至善服務，統一服務理念和價值觀`,
  t761: `城市服務`,
  t762: `多元創新，個性定製`,
  t763: `因地制宜，因時施策，創新探索個性化服務產品`,
  t764: `多元服務`,
  t765: `多元引擎，全景生態`,
  t766: `圍繞社區生活場景，聚焦客戶全景生態服務需求`,
  t767: `個酒店`,
  t768: `保利商旅 邂逅美好`,
  t769: `保利商旅酒店管理有限公司是保利置業集團有限公司全資子公司，是融合酒店、商業、寫字樓、健身等多業態、市場化、品牌化的酒店及商業資產管理公司，負責置業集團自營酒店項目的經營管理，外資酒店品牌的業主管理、部分商業及寫字樓管理、健身房運營及新項目的開發等。`,
  t770: `目前，主業酒店板塊已佈局在全國8個城市共9家酒店，既有位於一線城市核心區的高端商務型酒店，也有位於城市周邊的溫泉酒店、景區酒店等項目。其中委託管理酒店項目4家分別與洲際酒店集團和凱悅酒店集團合作，分別是上海嘉定凱悅酒店、柳州凱悅嘉軒酒店、德清凱悅嘉軒酒店、順德保利假日酒店；自營酒店5家，包括北京保利大廈酒店、湖北保利大酒店、貴陽保利國際溫泉酒店、四川保利新九寨賓館及四川華龍山莊等。`,
  t771: `旗下業務`,
  t772: `酒店`,
  t773: `健身`,
  t774: `商業`,
  t775: `負責置業集團自營酒店項目的經營管理、外資品牌的業主管理，`,
  t776: `在全國8座城市經營9家四星、五星酒店；`,
  t777: `瀏覽網站`,
  t778: `保利健身是保利商旅生活服務品牌，我們以央企的品質與責任為基礎理念，`,
  t779: `為社區、家庭和個人打造高標準的健康休閒空間，傳遞保利品牌的`,
  t780: `服務理念、文化精神， 以及活力、勇敢與愛。`,
  t781: `商業部分包括商業寫字樓的管理及房地產商業租賃，`,
  t782: `通過多年豐富的經驗，引進海內外優質商業資源，盤活存量資源。`,
  t783: `暖意歸家`,
  t784: `用最熱情溫暖的態度，迎接每一個來到保利酒店的客戶，`,
  t785: `好像迎接家人歸來一般。`,
  t786: `為客移駕 ｜ 盛迎佳客 ｜ 代持行李 ｜ 全程引導 ｜ 敬誠問候 ｜ 舒心辦理`,
  t787: `心安無憂`,
  t788: `用最專業的服務滿足客戶的各方面基礎需求，`,
  t789: `做到積極、專業、準確、及時服務。`,
  t790: `引客入居 ｜ 行李隨行 ｜ 自報家門 ｜ 臻味上門 ｜ 佳餚品讀`,
  t791: `舒適怡然`,
  t792: `從滿足客戶需求出發，各環節的高標準服務，`,
  t793: `為客戶打造全方位的舒適體驗。`,
  t794: `遇客喜相迎 ｜ 舒適浴感 ｜ 品質用品 ｜ 親膚浴巾 ｜ 適宜體感 ｜ 宜人床品 ｜ 宜寢軟榻`,
  t795: `美好可期`,
  t796: `保利商旅酒店的個性化的服務，提供超越期待的驚喜，`,
  t797: `為旅途留下更加美好的回憶。`,
  t798: `餐前問候 ｜ 敬請入座 ｜ 佳餚介紹 ｜ 高效結賬 ｜ 用餐反饋 ｜ 辦理離店 ｜ 體驗反饋 ｜ 送客禮儀`,
  t799: `吾鄉有情`,
  t800: `我們不止關心我們的客人，更關心社會的福祉，關心自然。`,
  t801: `時刻肩負作為一個央企品牌的社會責任。`,
  t802: `保利酒店酒店長期致力於社區建設、特殊人群關愛、環境保護和可持續發展，為社會美好發展貢獻自己的力量。`,
  t803: `小保的誕生`,
  t804: `小保大事記`,
  t805: `小保樂園`,
  t806: `小保繪本`,
  t807: `小保文創小宇宙`,
  t808: `品牌體系`,
  t809: `品牌IP`,
  t810: `責任品牌`,
  t811: `保利置業始終堅持"保利是吾鄉"品牌願景，以"心安吾鄉"為品牌主張，以人本主義為精神內核，以產品主義為硬核實力，以專業主義為重要抓手，始終堅持長期主義為發展導向，以"至真、致美、置吾鄉"為客戶宣言，通過產品、服務、文化、責任四大品牌建設觸點，提升市場化品牌影響力，聚焦"品質五力"、"服務五心"核心競爭力，打造具有卓越競爭力的品牌生態鏈，為廣大客戶和業主兌現美好期許。`,
  t813: `小保的誕生`,
  t814: `小保大視界`,
  t815: `小保樂園`,
  t816: `小保繪本`,
  t817: `小保元宇宙`,
  t818: `品牌體系`,
  t819: `品牌IP`,
  t820: `責任品牌`,
  t821: `我的崗位`,
  t822: `中國保利集團 | 首席美好獅`,
  t823: `我的星座`,
  t824: `獅子座`,
  t825: `我的性格`,
  t826: `樂觀陽光 自信果敢 社交達人`,
  t827: `我的告白`,
  t828: `你是我的保`,
  t829: `我的超能力`,
  t830: `外貌：`,
  t831: `化身美好之獅，象徵力量與無畏擔當`,
  t832: `頭髮：`,
  t833: `身披火焰，用卓越之心點亮世間美好`,
  t834: `眼鏡：`,
  t835: `頭戴四次元眼鏡，發現美好探索時空`,
  t836: `尾焰：`,
  t837: `燃燒的星火，賦予魔法棒的改變之力`,
  t838: `美好吾鄉 一起出發`,
  t839: `2024懷揣"保利是吾鄉"的品牌願景`,
  t840: `小保與你一同卓越前行`,
  t841: `是我全新的品牌主張`,
  t842: `擔綱央企責任，保有美好之心`,
  t843: `我們不斷踐行運營城市美好的方方面面`,
  t844: `致力於打造吾心安處的幸福空間和心靈歸屬`,
  t845: `成長的陪伴 生活的樂園`,
  t846: `在每一個孩子心中`,
  t847: `幾乎都有一個像孫悟空…奧特曼一樣的超級偶像存在`,
  t848: `不僅是孩子們成長時光中的陪伴者`,
  t849: `更成為深刻影響他們成長的精神力量`,
  t850: `我們希望`,
  t851: `小保能夠為孩子們的成長注入光的力量`,
  t852: `讓每一天都充滿驚喜`,
  t853: `為孩子們打造專屬的成長樂園`,
  t854: `小保童行 共繪美好`,
  t855: `繪本，作為孩子"人生中的第一本書"，`,
  t856: `正逐漸發展成全民剛需、高頻使用的親子陪伴場景，`,
  t857: `並成為家庭教育的標配。`,
  t858: `我們將中國優秀傳統文化融入原創兒童繪本，`,
  t859: `打造"小保繪本"專屬系列，`,
  t860: `助力培養孩子的世界觀和學習觀，`,
  t861: `樹立民族自信心、提升民族自豪感。`,
  t862: `為保利業主家庭，帶來更美好的陪伴。`,
  t863: `多元美好 探索無限`,
  t864: `這是一個擁抱無限可能的平台，`,
  t865: `打造情感的超級社群？創造智慧的科技未來？`,
  t866: `搭建藝文的交流平台？智造文創的豐富周邊？`,
  t867: `小保願與大家攜手共創美好吾鄉！`,
  t868: `關於我們`,
  t869: `向新保利 美好生活的領創者`,
  t870: `蓬勃保利 務實篤行的奮鬥者`,
  t871: `商旅保利 星級酒店的鑄築者`,
  t872: `責任保利 鄉村振興的踐行者`,
  t873: `匠心保利 城市地標的建造者`,
  t874: `家國保利 國寶獸首的守護者`,
  t875: `創新保利 高新科技的探索者`,
  t876: `美好保利 社區治理的耕耘者`,
  t877: `時代保利 國家開放的見證者`,
  t878: `保國利民 國資在港的擔當者`,
  t879: `保利置業的誕生、成長與壯大，與國家戰略發展緊密相連。1993年，中國保利集團完成香港上市公司新海康航業投資有限公司(H.K. 00119) 55%的股權收購，實現在港主板上市。保利（香港）控股先後參與廣州中信廣場、北京新保利大廈等項目開發建設，佈局香港龍譽、瑧譽、沄璟等多個行業標杆，累計在港創造數千個崗位，服務近千個家庭。`,
  t880: `領潮保利 時代人居的助推者`,
  t881: `1992年，中國保利集團取得第一張涉外國有土地使用證（京中外國用（92）字第0001號）。這份土地證見證了麗京花園項目從籌建、選址、立項、施工，到銷售、物業管理的每一個環節。作為北京市第一個涉外商品房項目，也是中國保利集團第一個房地產項目，在內地和香港兩地同時銷售的麗京花園，吸引大量華僑、港澳台同胞購買定居，創下了"4小時銷售60套"的保利傳奇。第一張涉外國有土地使用證，親鑒一代代保利人進取的奮鬥史，成為保利人奮進的精神力量。`,
  t882: `四十有為`,
  t885: `© 2024 中國保利集團 版權所有。`,
  t886: `滬ICP備09090711號-2`,
  t887: `滬公網安備 31011502015790號`,
  t888: `首頁`,
  t889: `關於我們`,
  t890: `中國保利集團`,
  t892: `組織架構`,
  t893: `品牌文化`,
  t894: `發展歷程`,
  t895: `新聞動態`,
  t899: `多元業務`,
  t900: `房地產開發`,
  t901: `物業服務`,
  t902: `商旅服務`,
  t903: `科技創新`,
  t912: `可持續發展`,
  t922: `聯繫我們`,
  t923: `（主席）`,
  t924: `香港`,
  t925: `業務領域`,
  t926: `測速中`,
  t927: `延遲`,
  t928: `請選擇適合您的線路`,
  t929: `歡迎訪問`,
}
